import React from "react";
import { CheckCircle } from "@material-ui/icons";
import PropTypes from "prop-types";

import { useStyles } from "./SelectItemBox.styles";

const SelectItemBox = ({ onSelect, value, allowedtarget, label }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.head}>{label}</div>
      {allowedtarget?.map((item, index) => {
        return (
          <div
            key={index}
            className={`${classes.selectItem} ${
              item.type === value ? classes.active : ""
            }`}
            onClick={() => {
              onSelect(item.type);
            }}
            data-testid={`item-${index}`}
          >
            <div className={classes.left}>
              <span className={classes.icon}>{item.icon}</span>
              <span className={classes.label}>{item.name}</span>
            </div>
            {value === item.type && (
              <div className={classes.right}>
                <CheckCircle className={classes.checkIcon}></CheckCircle>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

SelectItemBox.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  allowedtarget: PropTypes.array,
  onSelect: PropTypes.func,
  label: PropTypes.string,
};

export { SelectItemBox };
